import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./customStyle.css"
import { aboutPageAssets } from '../../../../assets/media';


const FeaturedSliderComponent = ({ images, customSettings, customStyle = '', customImgStyle = '', shuffleBy = 1 }) => {
    const { craft, capterra, g2, crozdeck, softSuggest } = aboutPageAssets
    const hrMarketPlaces = [
        {
            caption: "Craft.co",
            url: craft
        },
        {
            caption: "Capterra",
            url: capterra
        },
        {
            caption: "G2",
            url: g2
        },
        {
            caption: "Crozdeck",
            url: crozdeck
        },
        {
            caption: "Software Suggest",
            url: softSuggest
        },
    ]


    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        ...customSettings
    };




    return (
        <>

            <div className={`carousel mx-auto py-5 mb-10 lg:hidden   ${customStyle}`}>

                <Slider {...settings} >
                    {
                        hrMarketPlaces.map((hrMarketPlace, index) => (
                            <div className="marketPalce mb-5  !flex !flex-col !justify-center !items-center" key={index}>
                                <img className='object-contain  h-[5rem] mb-5' src={hrMarketPlace.url} alt={hrMarketPlace.caption} />
                                <p className='text-center'>{hrMarketPlace.caption}</p>
                            </div>
                        ))
                    }

                </Slider>
            </div>


        </>
    )
}

export default FeaturedSliderComponent